import api from "./axios";

export const addBookingApi = (leadId, type, payload) =>
  api.post(`/leads/${leadId}/bookings/${type}`, payload);

export const updateBookingApi = (leadId, type, bookingId, payload) =>
  api.put(`/leads/${leadId}/bookings/${type}/${bookingId}`, payload);

export const deleteBookingApi = (leadId, type, bookingId) =>
  api.delete(`/leads/${leadId}/bookings/${type}/${bookingId}`);
